import React ,{useContext} from 'react'
import { Container, Row, Col } from 'reactstrap'
import {themeContext} from '../../Context'

import './Services.css'
const Services = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    const services = [
        {
            icon: 'ri-code-s-slash-line',
            title: 'Web Developement (Front-end Engineering)',
            desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime aut quis alias ducimus magni consequatur optio at ipsam, qui velit cumque earum aliquam est sapiente eius! Dolore eum excepturi officiis.',
            skills: 'React JS, Angular, OJET, CSS, JavaScript, HTML'
        }, {
            icon: 'ri-codepen-line',
            title: 'Web Developement  (Full-stack Engineering)',
            desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime aut quis alias ducimus magni consequatur optio at ipsam, qui velit cumque earum aliquam est sapiente eius! Dolore eum excepturi officiis.',
            skills: 'React JS, Angular, OJET, CSS, JavaScript, HTML, Java, C, Python'
        }
    ]
    return (
        <Container id='services' className='mb-5'>
            <Row>
                <Col lg='12' className='services_top mb-5'>
                    <h2> What services I provide </h2>
                </Col>
                {services.map((item, index) => (
                    <Col key={index} lg='4' md='6' sm='6' className='mb-4'>
                        <div className={`single_service ${darkMode ? 'single_service_dark':'single_service_light'}`}>
                            <span className={`${darkMode?'service_icon_dark':'service_icon_light'}`}>
                                <i className={item.icon}> </i>
                            </span>
                            <h2>{item.title}</h2>
                            {/* <p>{item.desc}</p> */}
                            <span style={{color: darkMode?'#7865ff':'#00509d'}}>Skills: <span className={`${darkMode?'single_skills_dark':'single_skills_light'}`}> {item.skills}</span></span>
                        </div>
                    </Col>))}
            </Row>
        </Container >
    )
}

export default Services